import React, { useState } from 'react'
import {
	Text,
	Flex,
	Box,
	Accordion,
	AccordionButton,
	AccordionIcon,
	AccordionItem,
	AccordionPanel,
	VStack,
	CircularProgress,
	CircularProgressLabel,
	Icon,
	Avatar,
	Spinner,
	Center,
} from '@chakra-ui/react'
import SVGIcon from '../../../../assets/svgIcons'
import { useSharedContext } from '../../../../context/shared.context'
import { BiChevronUp } from 'react-icons/bi'
import profilePic from '../../../../assets/images/profile_pic.png'
import './status-style.css'
import StatusTimer from '../../../../components/activity-status-timer'
import { getStatusLifeCycleDateFormat } from '../../../../utils/date.utils'
import { getDeclineTimeDate } from './../../../../utils/date.utils'
import { STATUS_PROGRESS, STATUS_PUNCTUALITY } from './status.constant'

const StatusFormListUI = props => {
	const { statusAndFormsList, isLoading } = props
	const {
		state: { activity },
	} = useSharedContext()

	const [expandFlag, setExpandFlag] = useState(false)

	if (isLoading)
		return (
			<Center>
				<Spinner color='brand.700' />
			</Center>
		)

	const isCurrentStatus = status => {
		return status.status_progress === STATUS_PROGRESS.CURRENT_STATUS
	}

	const getCircularProgressValue = status => {
		// Future Statuses - 100%
		if (
			status.status_progress !== STATUS_PROGRESS.COMPLETED &&
			!isCurrentStatus(status)
		)
			return 100

		return (status?.forms_submitted / status?.forms?.length) * 100
	}

	const getColorBasedOnPunctuality = punctuality => {
		let color
		switch (punctuality) {
			case STATUS_PUNCTUALITY.ON_TIME:
				color = '#009B76'
				break
			case STATUS_PUNCTUALITY.SLIGHT_DELAY:
				color = '#FF9800'
				break
			case STATUS_PUNCTUALITY.DELAY:
				color = '#EF3D3D'
				break
			default:
				color = '#ADADAD'
		}
		return color
	}

	const renderStatusPunctuality = status => {
		if (!!status.status_punctuality) {
			const color = getColorBasedOnPunctuality(status.status_punctuality)
			return (
				<Text
					ml='4px'
					fontWeight='400'
					fontStyle='italic'
					fontSize='11px'
					color={color}
				>
					{status.status_punctuality}
				</Text>
			)
		} else if (status.status_progress === STATUS_PROGRESS.SKIPPED) {
			return (
				<Text
					ml='4px'
					fontWeight='400'
					fontStyle='italic'
					fontSize='11px'
					color='#7E7E7E'
				>
					{status.status_progress}
				</Text>
			)
		}
	}

	const renderStatusProgressIcon = status => {
		const color = getColorBasedOnPunctuality(status.status_punctuality)
		if (status.status_progress === STATUS_PROGRESS.COMPLETED)
			return (
				<SVGIcon
					iconName='CheckedSvg'
					svgProps={{
						width: '13',
						height: '12',
						viewBox: '0 0 13 12',
					}}
					pathProps={{ fill: '#009B76' }}
				/>
			)
		else if (status.status_progress === STATUS_PROGRESS.CURRENT_STATUS)
			return (
				<SVGIcon
					iconName='DelayedSmallSvg'
					svgProps={{
						width: '15',
						height: '14',
						viewBox: '0 0 15 14',
					}}
					pathProps={{
						fill: color,
					}}
				/>
			)
	}

	const renderStatusTime = status => {
		if (!!status.status_completed_time)
			return (
				<Text
					ml='4px'
					fontWeight='400'
					fontStyle='italic'
					fontSize='11px'
					color='black'
				>
					{`${getStatusLifeCycleDateFormat(status.status_completed_time)} | `}
				</Text>
			)
		else if (!!status.current_status_deadline)
			return (
				<Text
					ml='4px'
					fontWeight='400'
					fontStyle='italic'
					fontSize='11px'
					color='black'
				>
					{`${getStatusLifeCycleDateFormat(status.current_status_deadline)} | `}
				</Text>
			)
	}

	return (
		<Accordion
			allowToggle
			flex='1'
			ml='30px'
			mt='25px'
			mb='25px'
			overflowY='auto'
			pt='1rem'
		>
			{(statusAndFormsList || []).map(status => {
				return (
					<Flex key={status.activity_status_id}>
						<Flex>
							<Box
								borderLeft='2px dashed'
								borderLeftColor={
									isCurrentStatus(status) ? '#a6a6a6' : '#009b76'
								}
								w='2px'
								ml='30px'
								mt={expandFlag ? '10px' : '0px'}
							></Box>
						</Flex>
						<AccordionItem
							border='none'
							mb={isCurrentStatus(status) ? '15px' : '20px'}
							ml='-20px'
							w='80%'
						>
							{({ isExpanded }) => (
								<>
									<Flex ml={isExpanded ? '45px' : '0px'} borderLeft='none'>
										<Box
											flex='1'
											boxShadow={
												isCurrentStatus(status)
													? '6px 5px 6px -2px #adabab'
													: ''
											}
											borderRadius={isCurrentStatus(status) ? 'lg' : ''}
											ml={
												isCurrentStatus(status) && !isExpanded
													? '45px'
													: !isCurrentStatus(status) && !isExpanded
													? '0px'
													: '0px'
											}
											background={
												isCurrentStatus(status)
													? 'linear-gradient(270deg, white, rgba(255, 255, 255, 0))'
													: ''
											}
											borderLeft='none'
										>
											<h2>
												<Box
													ml={
														isExpanded || isCurrentStatus(status)
															? '-45px'
															: '0px'
													}
												>
													<AccordionButton
														w='100%'
														pl='0px'
														pb='0px'
														pt={
															isCurrentStatus(status)
																? '15px'
																: isExpanded
																? '10px'
																: '0px'
														}
														pr='20px'
														mb='15px'
														mt='0px'
														_hover={{
															border: 'none',
															bg: 'none',
														}}
														onClick={() => {
															setExpandFlag(true)
														}}
													>
														<Flex
															justifyContent='space-between'
															flex='1'
															alignItems='flex-start'
														>
															<Flex
																justifyContent='space-around'
																alignItems='center'
																gap='20px'
															>
																<Flex
																	justifyContent={'center'}
																	alignItems='center'
																	w='35px'
																	mt={isCurrentStatus(status) ? '-47px' : '0px'}
																>
																	{!isCurrentStatus(status) ? (
																		<CircularProgress
																			value={getCircularProgressValue(status)}
																			color={getColorBasedOnPunctuality(
																				status.status_punctuality
																			)}
																			size='30px'
																			stroke='#666'
																			thickness={
																				status.status_progress ===
																				STATUS_PROGRESS.COMPLETED
																					? '12px'
																					: '10px'
																			}
																			bg='white'
																			borderRadius={'50%'}
																		>
																			<CircularProgressLabel fontSize='15px'>
																				{status?.forms?.length}
																			</CircularProgressLabel>
																		</CircularProgress>
																	) : (
																		<Box
																			className='pulse1'
																			bg={getColorBasedOnPunctuality(
																				status.status_punctuality
																			)}
																		>
																			<Box
																				as='span'
																				style={{ '--i': '1' }}
																			></Box>
																			<Box
																				as='span'
																				style={{ '--i': '2' }}
																			></Box>
																			<Box
																				as='span'
																				style={{ '--i': '3' }}
																			></Box>
																			<CircularProgress
																				value={getCircularProgressValue(status)}
																				color={getColorBasedOnPunctuality(
																					status.status_punctuality
																				)}
																				size='30px'
																				thickness='11px'
																				bg='white'
																				borderRadius={'50%'}
																			>
																				<CircularProgressLabel
																					fontSize={'15px'}
																				>
																					{status?.forms?.length}
																				</CircularProgressLabel>
																			</CircularProgress>
																		</Box>
																	)}
																</Flex>
																<Flex flexDir={'column'}>
																	<Flex>
																		<Text
																			fontWeight={
																				isCurrentStatus(status) ? '900' : '500'
																			}
																			fontSize={
																				isCurrentStatus(status)
																					? '15px'
																					: '14px'
																			}
																		>
																			{status.activity_status_name}{' '}
																		</Text>
																	</Flex>
																	<Flex>
																		{renderStatusProgressIcon(status)}
																		{renderStatusTime(status)}
																		{renderStatusPunctuality(status)}
																	</Flex>
																	{isCurrentStatus(status) &&
																		!!activity.activity_lead_operating_asset_first_name && (
																			<Flex mt='5px' alignItems={'center'}>
																				<Avatar
																					name={
																						activity.activity_lead_operating_asset_first_name
																					}
																					color={'white'}
																					bg={
																						!!activity.activity_lead_asset_image_path
																							? ''
																							: '#009b76'
																					}
																					size='sm'
																					src={
																						!!activity.activity_lead_asset_image_path
																							? profilePic
																							: ''
																					}
																				/>
																				<Text
																					ml='5px'
																					fontSize={'14px'}
																					fontWeight='800'
																					color='black'
																				>
																					{`${activity.activity_lead_operating_asset_first_name} (Lead)`}
																				</Text>
																			</Flex>
																		)}
																</Flex>
															</Flex>
															<Flex
																justifyContent='space-between'
																alignItems='center'
																alignSelf={
																	isCurrentStatus(status)
																		? 'flex-start'
																		: 'center'
																}
																gap={isCurrentStatus(status) ? '15px' : '0px'}
															>
																{isCurrentStatus(status) &&
																status.activity_status_duration !== 0 ? (
																	<Flex
																		justifyContent={'space-around'}
																		alignItems='center'
																	>
																		<SVGIcon
																			iconName='HourGlassSvg'
																			svgProps={{
																				width: '15',
																				height: '14',
																				viewBox: '0 0 15 14',
																			}}
																		/>
																		<Text
																			ml='5px'
																			color={
																				isCurrentStatus(status)
																					? 'red'
																					: 'black'
																			}
																			fontWeight='500'
																			fontSize={'12px'}
																		>
																			<StatusTimer
																				statusDueDate={
																					status.current_status_deadline
																				}
																			/>
																		</Text>
																	</Flex>
																) : null}
																<Flex
																	cursor={'pointer'}
																	mr={isExpanded ? '-4px' : '0px'}
																>
																	{!isExpanded ? (
																		<SVGIcon
																			iconName='ForwardArrowSvg'
																			svgProps={{
																				width: '9',
																				height: '14',
																				viewBox: '0 0 9 14',
																			}}
																			pathProps={{ fill: '#009B76' }}
																		/>
																	) : (
																		<Icon
																			as={BiChevronUp}
																			color='brand.700'
																			w={7}
																			h={7}
																		/>
																	)}{' '}
																</Flex>
															</Flex>
														</Flex>
													</AccordionButton>
												</Box>
											</h2>
											<AccordionPanel
												pt='10px'
												pb='0px'
												pl='19px'
												pr='0px'
												ml={!isExpanded ? '45px' : '0px'}
												minH='70px'
												maxH='200px'
												overflowY={'auto'}
												mr='10px'
												mb='20px'
											>
												{status.forms?.length > 0 ? (
													(status.forms || []).map(form => {
														return (
															<Flex
																key={form.form_id}
																borderLeft='2px dashed'
																borderColor={
																	form.isSubmitted ? '#009b76' : '#a6a6a6'
																}
																ml='5px'
															>
																<Flex
																	justifyContent='space-between'
																	flex='1'
																	alignItems='flex-start'
																	mb='30px'
																>
																	<Flex
																		justifyContent='space-around'
																		alignItems='center'
																		gap='10px'
																		ml='-19px'
																	>
																		<Flex
																			justifyContent={'center'}
																			alignItems='center'
																			w='35px'
																			mt={form.isSubmitted ? '-10px' : '-10px'}
																		>
																			<CircularProgress
																				value={100}
																				color={
																					form.isSubmitted
																						? '#009b76'
																						: '#ADADAD'
																				}
																				size='24px'
																				thickness='10px'
																				bg='white'
																				borderRadius={'50%'}
																			/>
																		</Flex>
																		<Flex flexDir={'column'} mt='-5px'>
																			<Flex>
																				<Text
																					fontWeight='500'
																					fontSize='0.875rem'
																				>
																					{form.form_name}
																				</Text>
																			</Flex>
																			{form.isSubmitted && (
																				<Flex>
																					<SVGIcon
																						iconName='CheckedSvg'
																						svgProps={{
																							width: '13',
																							height: '12',
																							viewBox: '0 0 13 12',
																						}}
																						pathProps={{ fill: '#009B76' }}
																					/>
																					<Text
																						ml='4px'
																						fontWeight='400'
																						fontStyle='italic'
																						fontSize='11px'
																					>
																						{getDeclineTimeDate(
																							form.timeline_transaction_datetime
																						)}
																					</Text>
																				</Flex>
																			)}
																		</Flex>
																	</Flex>
																	<Flex
																		flexDir={'column'}
																		justifyContent='space-between'
																		alignItems='flex-end'
																		alignSelf={
																			isCurrentStatus(status)
																				? 'flex-start'
																				: 'center'
																		}
																		gap={
																			isCurrentStatus(status) ? '15px' : '0px'
																		}
																	></Flex>
																</Flex>
															</Flex>
														)
													})
												) : (
													<Text textAlign={'center'} color='red.500'>
														No Forms Available
													</Text>
												)}
											</AccordionPanel>
										</Box>
									</Flex>
								</>
							)}
						</AccordionItem>
					</Flex>
				)
			})}
		</Accordion>
	)
}
export default StatusFormListUI
